import type TerritoryModel from "@esWebAPI/es/map/TerritoryModel";
import type { LayerInfo } from "@esWebAPI/es/model/Layer";

const es = global.es;
const esApp = global.esApp; // TODO FIXME esApp ref in API code!!!!

export default class TerritoryPointStyler {
    /**
     * 
     * @param styler 
     * @param style 
     * @param feature 
     * @param layerViewInfo 
     * 
     * @returns 
     */
    getStyle(styler, style, feature, layerViewInfo: LayerInfo) {
        const territoryModel: TerritoryModel = esApp.map.layer.getTerritoryModel(); // TODO pass in model ref
        const level = territoryModel.getCurrentLevel();

        const terr = territoryModel.getTerritoryForPointFeature(layerViewInfo.layerMetaId, feature, level);

        if (terr) {
            style = es.util.object.deepCopy(styler.defaultStyle);
            style.color = terr.ES_STYLE_COLOR;
        }

        return style;
    }

    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    getPaddingPx(styler): number[] {
        return es.util.style.types[styler.defaultStyle.$type].getPaddingPx(styler.defaultStyle);
    }

    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    hasDirect(styler): boolean {
        return false;
    }

    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    hasOverlays(styler): boolean {
        return true;
    }

    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    getHideFeaturesCriteria(styler) {
        return null;
    }
}
